/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_1Inputs */



/**
* | output |
* | --- |
* | "Copy the Machine ID from above" |
*
* @param {Login_Offline_Instruction_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_1 = /** @type {((inputs?: Login_Offline_Instruction_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copiez l'ID de Machine ci-dessus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren Sie die Maschinen-ID von oben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia l'ID macchina dall'alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопируйте идентификатор машины, указанный выше.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar el ID de la máquina de arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从上方复制机器 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上記のマシンIDをコピーします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपर से मशीन आईडी कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copie o ID da máquina acima.")
	return /** @type {LocalizedString} */ ("Copy the Machine ID from above")
});